import { FieldViewModel, IOmniaCommand } from "../omnia";
import { commands } from "../strings";
import { IFieldsModuleContext } from "../types";

type Context = Omit<IFieldsModuleContext, "map" | "mapView">;

export class SplitCmd implements IOmniaCommand {

    text: string = commands.split;
    icon: string = "split";

    cropping: FieldViewModel;

    constructor(private context: Context) {
    }

    canExecute(cropping: FieldViewModel): boolean {

        return !!cropping?.cropping

    }

    execute(cropping: FieldViewModel) {

        this.cropping = cropping;

        return this.context.startComponent({ component: "omnia-fields-split-cropping", execArguments: this });

    }

    isActive(): boolean {
        // You can't click edit if we're already in the process of editing something.
        return !this.context?.editSvc?.isEditing;
    }


}
